// Copyright (c) 2022 Sagacity Solutions Inc. All right reserved.
'use strict'        ;

import Vue from "vue";
import api from "@/api/users";

export default {
    namespaced: true,
    state: {
        list: [],
        selectedUser: undefined,
    },
    mutations: {
      setUsers(state, users) {
        state.list = users || []
      },
      addNewUser(state, user) {
        state.list.push(user);
      },
      removeUser(state, user) {
        let u = state.list.find(function(item) {
            return item.ID === user.ID;
        });

        let idx = state.list.indexOf(u);
        if (idx > -1) {
            state.list.splice(idx, 1);
        }
      },
      updateUser(state, user) {
        let u = state.list.find(function(item) {
            return item.ID === user.ID;
        });

        let idx = state.list.indexOf(u);
        if (idx > -1) {
          const copy_user = Object.assign({}, user)
          Vue.set(state.list, idx, copy_user);
          state.selectedUser = copy_user;
        }
      },
      setSelectedUser(state, user) {
        let u = state.list.find(function(item) {
            return item.ID === user.ID;
        });

        state.selectedUser = u;
      }
    },
    actions: {
      async getAll({commit}) {
        let data = await api.get();
        console.log(data);
        commit('setUsers', data);
      },
      async save({commit}, user) {
        let data = await api.save(user)
        if (data != null) {
          commit('updateUser', data)
        }
      },
      async create({commit}, user) {
        let data = await api.create(user)
        if (data != null) {
          commit('addNewUser', data);
        }
      },
      async delete({commit}, user) {
        let ok = await api.remove(user);
        if (!ok)
          throw 'error removing user'
        commit('removeUser', user)
      }
    }
}
